import { render } from "./FolderView.vue?vue&type=template&id=f2ebdc84"
import script from "./FolderView.vue?vue&type=script&lang=js"
export * from "./FolderView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__